import React from 'react'
import UserAuthContext from '@/context/userAuthContext';

const useAuth = () => React.useContext(UserAuthContext);

export default useAuth
